"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const use_localstorage_1 = require("./use-localstorage");
exports.useLocalStorage = use_localstorage_1.useLocalStorage;
var local_storage_events_1 = require("./local-storage-events");
exports.writeStorage = local_storage_events_1.writeStorage;
exports.deleteFromStorage = local_storage_events_1.deleteFromStorage;
exports.default = use_localstorage_1.useLocalStorage;
//# sourceMappingURL=index.js.map